/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Product_LabelInputs */

const en_cargo_product_label = /** @type {(inputs: Cargo_Product_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product *`)
};

const es_cargo_product_label = /** @type {(inputs: Cargo_Product_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto *`)
};

/**
* | output |
* | --- |
* | "Product *" |
*
* @param {Cargo_Product_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_product_label = /** @type {((inputs?: Cargo_Product_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Product_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_product_label(inputs)
	return es_cargo_product_label(inputs)
});